<template>
    <Page withNavbar withNavigation>
        <header>
            <SectionTitle
                class="title"
                :title="config.BRIEF_STEPS_TITLE"
                :description="config.BRIEF_STEPS_DESCRIPTION"
            />
            <section v-if="config.BRIEF_STEPS_IMAGE || briefVideoUrl" class="visual">
                <Picture v-if="config.BRIEF_STEPS_IMAGE" :src="config.BRIEF_STEPS_IMAGE"/>
                <Video v-else :src="briefVideoUrl"/>
            </section>
        </header>
        <main>
            <div v-if="pdf || config.BRIEF_PDF_URL" class="downloadButton">
                <Button :color="config.COLOR_PRIMARY" outline>
                    <a :href="pdf || config.BRIEF_PDF_URL" target="_blank">{{ config.BRIEF_STEPS_DOWNLOAD }}</a>
                </Button>
            </div>
            <section class="steps">
                <BriefStep v-for="(step, index) in steps || briefSteps" :key="index" :step="step" :order="index + 1"/>
            </section>
            <SectionNavigation :to="{ name: next }"/>
        </main>
    </page>
</template>
<script>
import { SolutionConsumer } from '../../mixins';
import { Page, SectionNavigation } from '../../components/mobile';
import { BriefStep, SectionTitle } from '../../components/shared';

export default {
    name: 'BriefSteps',
    components: {
        Page, SectionNavigation, SectionTitle, BriefStep,
    },
    mixins: [SolutionConsumer],
    props: {
        next: {
            type: String,
            required: true,
        },
        steps: {
            type: Array,
            default: null,
        },
        pdf: {
            type: String,
            default: null,
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

header {
    background-color: $white;
    text-align: center;

    > .title {
        padding: 20px;
    }
}

main {
    @include container(40px 20px);

    > .downloadButton {
        display: flex;
        justify-content: center;
      }

    > .steps {
        display: grid;
        row-gap: 10px;
    }
}
</style>
